import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class NetworkingExponentSilver {
  public static async page(page: number, filters?: any) {
    try {
      useDispatch(Action.Networking.Exponent.Silver.setStatus("loading"));
      const response = await new Model.Networking.Exponent.Silver().page(page, filters);
      useDispatch(Action.Networking.Exponent.Silver.setData(response.data));
      useDispatch(Action.Networking.Exponent.Silver.setStatus("loaded"));
      return response.data;
    } catch (Exception) {
      throw Exception;
    }
  }
}
